import themeBase from "../../../../utils/theme/themeBase";
import { useBoolean } from "@fluentui/react-hooks";
import { UseTipoEquipoTable } from "./UseTipoEquipoTable";
import { TableComponent } from "../../../../components/Table/TableComponent";
import { IButtonGroup, IColumn } from "../../../../Interfaces/filter";
import { DetailsListLayoutMode, ICommandBarItemProps, Icon, TooltipHost } from "@fluentui/react";
import { ITipoEquipoEdit } from "../../../../Interfaces/ListaVerificacion/TipoEquipo/ITIpoEquipo";
import { useState } from "react";
import { PanelCrearTipoEquipo } from "./TipoEquipoCrear/PanelCrearTipoEquipo";
import { PanelTipoEquipoEditar } from "./TipoEquipoEditar/PanelTipoEquipoEditar";
import { PanelTipoEquipoEliminar } from "./TipoEquipoEliminar/PanelTipoEquipoEliminar";
import { Button } from "@fluentui/react-components";
import { useIconsCatalogo } from "../../../../components/iconCatalog/common.useIconsCatalogo";
import { EditRegular, DeleteRegular } from "@fluentui/react-icons";
import { CommonHeaderComponent } from "../../../../components/generic/common.Header";
import IconHelper from "../../../../utils/helpers/iconHelper";
import { CabeceraTable } from "../../../../components/Table/CabeceraTable";
import { TableBaseComponent } from "../../../../components/Table/TableBaseComponent";
import { TipoEquipoSync } from "./TipoEquipoSync/TipoEquipoSync";


export const TipoEquipoTable = () => {
  const iconDetalleStyle: React.CSSProperties | undefined = {
    cursor: "pointer",
    color: "#0078d4",
  };
  const [isOpenTipo, { setTrue: openPanelTipo, setFalse: closePanelTipo }] = useBoolean(false);
  const [isOpenSYNC, { setTrue: openPanelSYNC, setFalse: closePanelSYNC }] = useBoolean(false);
  const [isOpenFiltrar, { setTrue: openPanelFiltrar, setFalse: closePanelFiltrar }] = useBoolean(false);
  const [isOpenEditar, { setTrue: openPanelEditar, setFalse: closePanelEditar }] = useBoolean(false);
  const [isOpenEliminar, { setTrue: openPanelEliminar, setFalse: closePanelEliminar }] = useBoolean(false);
  const { items, filter, setFilter, loading, pagination, getTipoEquipo, handleResetUpdate, onChangeSearch,onChangeTake, _onkeyUpSearchTable} = UseTipoEquipoTable()
  const [item, setItem] = useState<ITipoEquipoEdit>({
    nombre: "",
    codigo: "", tipoEquipoId: ""

  })

  const buttonLeft: ICommandBarItemProps[] = [
    {
      ...IconHelper.ICON_RELOAD2,
      text: "Sincronizar",
      onClick: () => {
        openPanelSYNC()
      },
    },
    {
      ...IconHelper.ICON_RELOAD,
      text: "Actualizar",
      onClick: () => {
        handleResetUpdate()
      },
    }
  ];

  function renderOpciones(item: ITipoEquipoEdit) {
    return (
      <>
        <TooltipHost content={"Editar"}>
          <Icon
            iconName="Edit"
            className={themeBase.classNamesIcon.iconFont}
            style={{ cursor: "pointer", color: "#0078d3" }}
            onClick={() => {
              setItem(item)
              openPanelEditar()
            }}
          />
        </TooltipHost>
        <TooltipHost content={"Quitar"}>
          <Icon
            iconName="Delete"
            className={themeBase.classNamesIcon.iconFont}
            style={{ cursor: "pointer", color: "#0078d3" }}
            onClick={() => {
              setItem(item)
              openPanelEliminar()
            }}
          />
        </TooltipHost>
      </>
    );
  }
  const _columns = [
    {
      key: "index",
      name: "N°",
      fieldName: "index",
      minWidth: 80,
      maxWidth: 80,
    },
    {
      key: "codigo",
      name: "Código",
      fieldName: "codigo",
      minWidth: 350,
      maxWidth: 350,
    },
    {
      key: "nombre",
      name: "Nombre",
      fieldName: "nombre",
      minWidth: 350,
      maxWidth: 350,
    },
    {
      key: "opciones",
      name: "Opciones",
      minWidth: 100,
      maxWidth: 100,
      onRender: (item: any) => renderOpciones(item)
    }
  ]
  return (
    <>
      <CabeceraTable
        Titulo={"Tipo Equipo"}
        SubTitulo={"Gestión de Tipo de Equipos Auxiliares"}
        placeholder="Buscar por Código"
        componentRef={onChangeSearch}
        onKeyUp={_onkeyUpSearchTable}
      />
      <TableBaseComponent
        leftBar={buttonLeft}
        rigthBar={[]}
        data={items}
        column={_columns}
        isLoading={loading}
        getPageSize={onChangeTake}
        pagination={pagination}
        layout={DetailsListLayoutMode.justified}
        tableSiza
      />

      <PanelCrearTipoEquipo
        isOpen={isOpenTipo}
        onDismiss={closePanelTipo}
        reload={handleResetUpdate}
      />
      <PanelTipoEquipoEditar
        item={item}
        isOpen={isOpenEditar}
        onDismiss={closePanelEditar}
        reload={handleResetUpdate}
      />
      <TipoEquipoSync isOpen={isOpenSYNC} onDismiss={closePanelSYNC} reload={handleResetUpdate}/>
      {isOpenEliminar && <PanelTipoEquipoEliminar
        item={item}
        isOpen={isOpenEliminar}
        onDismiss={closePanelEliminar}
        reload={handleResetUpdate}
      />}
    </>
  )

}